var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"psGroups view"},[_c('ps-page-container',{attrs:{"site":{ site: 'Grupos' }}}),_c('ps-groups-dialog-crop-image'),_c('ps-groups-dialog-select-date'),_c('ps-groups-dialog-patients')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }